import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useAuthz from '../../hooks/useAuthz';
import MyDialog from '../Layout/MyDialog';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../Utils/FormatData';
import { useAlert } from 'react-alert';

const RequestPassAlertRenderer = (props) => {
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setDialogData] = useState({ type: '', data: {} });
  const [content, setContent] = useState('');
  const [dialogState, setDialogState] = useState();

  if (profil.profil !== 1 && profil.profil !== 2) {
    return null;
  }

  useEffect(() => {
    if (dialogState && dialogData.data) {
        axios({
          method: 'get',
          url: `${URL_API}/demande-passage/remove-alert`,
          params: { requestPassId: dialogData.data, userAction: user.user_id },
        })
          .then((r) => {
            alert.removeAll();
            alert.success('La suppression de l\'alerte a bien été effectuée avec succés');
            props.setNeedReload(true);
            setOpenDialog(false);
            setDialogState(null);
          })
          .catch((error) => {
            logError(alert, error);
          });
    }
  }, [dialogState]);

  const handleAlertClick = () => {
    setDialogData({ ...dialogData, data: props.data.id, type: 'delete' });
    setContent(() => {
      return (
        <>
          <div>Êtes-vous sûr de vouloir retirer l'alerte pour le dossier N°[<b>{props.data.id}</b>] ?</div>
        </>
      );
    });
    setOpenDialog(true);
  };

  return (
    <div>
      {
        props.data.metadata.tracingDossier.alert === true &&
        <FontAwesomeIcon icon={faCircle} style={{ color: '#f18d2d', height: '10px', cursor: 'pointer' }}
                         onClick={handleAlertClick} />
      }
      {
        !props.data.metadata.tracingDossier.alert === true && <span>-</span>
      }

      <MyDialog open={openDialog} handleClose={setOpenDialog} title="Retirer l'alerte" content={content}
                dialog={setDialogState} />
    </div>);
};

export default RequestPassAlertRenderer;
